// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1F3uM","rootSmall":"AddTileButton_rootSmall__Dlxky"};